/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ActiveDirectoryAction = {
    Continue: 'Continue',
    ShowBlockPage: 'ShowBlockPage',
    ValidationError: 'ValidationError'
} as const;
export type ActiveDirectoryAction = typeof ActiveDirectoryAction[keyof typeof ActiveDirectoryAction];


export function instanceOfActiveDirectoryAction(value: any): boolean {
    for (const key in ActiveDirectoryAction) {
        if (Object.prototype.hasOwnProperty.call(ActiveDirectoryAction, key)) {
            if (ActiveDirectoryAction[key as keyof typeof ActiveDirectoryAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActiveDirectoryActionFromJSON(json: any): ActiveDirectoryAction {
    return ActiveDirectoryActionFromJSONTyped(json, false);
}

export function ActiveDirectoryActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveDirectoryAction {
    return json as ActiveDirectoryAction;
}

export function ActiveDirectoryActionToJSON(value?: ActiveDirectoryAction | null): any {
    return value as any;
}

export function ActiveDirectoryActionToJSONTyped(value: any, ignoreDiscriminator: boolean): ActiveDirectoryAction {
    return value as ActiveDirectoryAction;
}

